import { useRef, useCallback } from "react";

/**
 * useDebouncedAsync – ruft einen async Callback maximal einmal pro Wert auf und
 * verwirft alle aelteren in-flight Requests. Loest nicht auf "keine Aenderung".
 *
 *   const debounced = useDebouncedAsync(async (code) => {...}, 350);
 *   debounced("ADM");
 */
export function useDebouncedAsync(fn, delayMs = 300) {
  const timerRef = useRef(null);
  const lastValueRef = useRef(undefined);
  const inFlightRef = useRef(0);

  return useCallback(
    (...args) => {
      const key = args.join("|");
      if (key === lastValueRef.current) return; // gleicher Wert -> nichts tun
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(async () => {
        lastValueRef.current = key;
        const myId = ++inFlightRef.current;
        try {
          await fn(...args);
        } finally {
          // Wenn waehrend des Calls ein neuer started wurde, sind wir veraltet
          if (myId !== inFlightRef.current) {
            // egal – wir markieren nichts
          }
        }
      }, delayMs);
    },
    [fn, delayMs]
  );
}
